import { cn } from '@/shared/lib/utils'

/**
 * NotificationDot - a small attention dot driven by the notification
 * infrastructure. Any surface (claims list row, claim record header,
 * registrations list, ...) can render it when the current user has an unread
 * notification for the record.
 *
 * Colour follows the notification ``level`` via design-system tokens - no
 * hardcoded hex:
 *   - attention -> ``--status-warn`` (amber)
 *   - critical  -> ``--status-error`` (red)
 *   - info      -> ``--ink-3`` (muted)
 */

type NotificationDotLevel = 'info' | 'attention' | 'critical'

const LEVEL_BG: Record<NotificationDotLevel, string> = {
  info: 'bg-[var(--ink-3)]',
  attention: 'bg-[var(--status-warn)]',
  critical: 'bg-[var(--status-error)]',
}

interface NotificationDotProps {
  level?: NotificationDotLevel
  title?: string
  className?: string
}

export function NotificationDot({
  level = 'attention',
  title = 'Needs attention',
  className,
}: NotificationDotProps) {
  return (
    <span
      role="status"
      aria-label={title}
      title={title}
      className={cn(
        'inline-block h-2 w-2 shrink-0 rounded-full',
        LEVEL_BG[level],
        className,
      )}
    />
  )
}
